import * as timeHelper from "../helpers/timeHelper"
import { IBreak, EBreakType } from "../models"
import strings from "../localization/strings"

export function getMobileBreakTimeInfoString(mobileBreak: IBreak): string {
    return mobileBreak.Type === EBreakType.TimeDuration ?
        strings.formatString(strings.after_x_mins, mobileBreak.DurationToTrigger) as string :
        `${timeHelper.getTimeStringSimpleFormatFromSimpleTime(mobileBreak.BreakWindowStartTime)} - ${timeHelper.getTimeStringSimpleFormatFromSimpleTime(mobileBreak.BreakWindowEndTime)}`
}